import { BlockVisualization } from 'webapp/enums/enums';

import VisualizationLineChart from 'webapp/models-custom/visualization/line-chart';

export default class VisualizationBarChart extends VisualizationLineChart {
	override visualizationType = BlockVisualization.BAR_CHART;

	override get showSplineChoice(): boolean {
		return super.showSplineChoice || this.hasAnyLines;
	}

	private get hasAnyLines() {
		return (
			this.getDataSelectsByColorGroups()[0]!.length > 0 ||
			this.blockSetup.secondaryDataSelects.some((ds) => {
				return ds.isAlwaysLine;
			})
		);
	}
}
